/** @format */

import HomeIcon from '@/assets/home_external_nav_icon.svg';
import { TTranslation } from '@/i18n/createProvider';
import { useAppTranslation } from '@/i18n/declarations';
import { Link } from 'gatsby';
import React, { FC } from 'react';
import { Container, ExternalNavItem, ExternalNavItemLink, ExternalNavItems, Wrapper } from './ExternalNavbar.style';
import { EXTERNAL_ITEMS } from './items';

interface ExternalNavbarProps {
  page: 'home' | 'page' | 'search' | 'blog' | 'listing';
}

export const ExternalNavbar: FC<ExternalNavbarProps> = ({ page }) => {
  const { t } = useAppTranslation();

  return (
    <Wrapper $border={page !== 'home'}>
      <Container $page={page}>
        <ExternalNavItems>
          {EXTERNAL_ITEMS.map(item => (
            <ExternalNavItem key={item.href}>
              {item.external && (
                <ExternalNavItemLink target="_blank" $active={item.active || false} href={t(item.href as TTranslation)}>
                  {item.home ? (
                    <>
                      <img src={HomeIcon} title="Home" alt="Homepage" />
                      {t(item.label as TTranslation)}
                    </>
                  ) : (
                    t(item.label as TTranslation)
                  )}
                </ExternalNavItemLink>
              )}
              {!item.external && (
                <>
                  {item.href && (
                    <ExternalNavItemLink
                      as={Link}
                      $active={item.active || false}
                      to={t(item.href as TTranslation)}
                      target="_blank"
                    >
                      {t(item.label as TTranslation)}
                    </ExternalNavItemLink>
                  )}
                  {!item.href && t(item.label as TTranslation)}
                </>
              )}
            </ExternalNavItem>
          ))}
        </ExternalNavItems>
      </Container>
    </Wrapper>
  );
};
